// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoSearchOutlinedSvg from "@fishx/icons-svg/es/asn/PtoSearchOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoSearchOutlined = function PtoSearchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoSearchOutlinedSvg
  }));
};

PtoSearchOutlined.displayName = 'PtoSearchOutlined';
export default React.forwardRef(PtoSearchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoSearchOutlined.js
// module id = 3921
// module chunks = 0